var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraduationUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 5.85059L19.375 6.50977V12.333H18.375V6.91504L17.4062 7.30859V14.5752H16.4854C14.0777 16.3243 11.6685 16.697 9.59961 16.4053C7.75036 16.1444 6.18669 15.3551 5.13965 14.5752H4.59375V14.1299C4.59134 14.1277 4.58834 14.1262 4.58594 14.124L4.59375 14.1152V7.69629L0 5.85059L10.8281 0L21 5.85059ZM10.5518 10.0908L5.59375 8.09766V13.6631C6.51351 14.3852 7.98389 15.1674 9.73926 15.415C11.7035 15.692 14.0428 15.3048 16.4062 13.375V7.71484L10.5518 10.0908ZM2.68848 5.67676L5.30176 6.72656H5.59375V6.84375L10.5508 8.83496L18.375 5.65918V5.62695L10.8203 1.28125L2.68848 5.67676Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduationUnion);
export default __webpack_public_path__ + "static/media/GraduationUnion.9e1a66b33f81ae0cc7091463fbe3e799.svg";
export { ForwardRef as ReactComponent };